import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import Seo from '@/components/Seo';
import { resultsSchema } from '@/lib/seo';
import ResultsHero from './components/ResultsHero';
import ResultsStrip from './components/ResultsStrip';
import FeaturedStory from './components/FeaturedStory';
import ResultsGrid from './components/ResultsGrid';
import WhatChanged from './components/WhatChanged';
import RoiVisual from './components/RoiVisual';
import TestimonialsSection from './components/TestimonialsSection';
import VideoProof from './components/VideoProof';
import BeforeAfter from './components/BeforeAfter';
import EngagementTypes from './components/EngagementTypes';
import AuthorityBridge from './components/AuthorityBridge';
import FinalCta from './components/FinalCta';

export default function Results() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Seo
        title="Client Results | Josh Hastings"
        description="Explore client results, case studies, and measurable marketing outcomes from businesses working with Josh Hastings across roofing, HVAC, hardscaping, and home services."
        canonical="https://joshuawhastings.com/results"
      />

      <JsonLd data={resultsSchema} />

      <Header />

      <main>
        <ResultsHero />
        <ResultsStrip />
        <FeaturedStory />
        <ResultsGrid />
        <WhatChanged />
        <RoiVisual />
        <TestimonialsSection />
        {/* <VideoProof /> */}
        <BeforeAfter />
        <EngagementTypes />
        <AuthorityBridge />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}
